import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-header bg-gray d-flex align-items-center justify-space-between" }
const _hoisted_2 = { class: "settings-body" }
const _hoisted_3 = { class: "p-20" }
const _hoisted_4 = { class: "p-20" }
const _hoisted_5 = { class: "p-20" }
const _hoisted_6 = { class: "p-20" }
const _hoisted_7 = { class: "p-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RTLModeSwitch = _resolveComponent("RTLModeSwitch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_HorizontalLayout = _resolveComponent("HorizontalLayout")!
  const _component_OnlySidebarDark = _resolveComponent("OnlySidebarDark")!
  const _component_OnlyHeaderDark = _resolveComponent("OnlyHeaderDark")!
  const _component_OnlyFooterDark = _resolveComponent("OnlyFooterDark")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'settings-sidebar bg-white transition',
      { active: _ctx.stateStoreInstance.settings },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "logo d-flex align-items-center" }, [
          _createElementVNode("h5", { class: "m-0 lh-1" }, "Theme Settings")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.settingsBtn && _ctx.stateStoreInstance.settingsBtn(...args)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "material-symbols-outlined" }, " close ", -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "title d-block text-black fw-medium" }, " RTL / LTR", -1)),
          _createVNode(_component_RTLModeSwitch)
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "title d-block text-black fw-medium" }, " Horizontal Layout ", -1)),
          _createVNode(_component_HorizontalLayout)
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "title d-block text-black fw-medium" }, " Only Sidebar Light / Dark ", -1)),
          _createVNode(_component_OnlySidebarDark)
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "title d-block text-black fw-medium" }, " Only Header Light / Dark ", -1)),
          _createVNode(_component_OnlyHeaderDark)
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "title d-block text-black fw-medium" }, " Only Footer Light / Dark ", -1)),
          _createVNode(_component_OnlyFooterDark)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([
      'settings-sidebar-overlay',
      { active: _ctx.stateStoreInstance.settings },
    ]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.settingsBtn && _ctx.stateStoreInstance.settingsBtn(...args)))
    }, null, 2)
  ], 64))
}